import styled from "styled-components";

import { media } from "../../../../../styles/media";

export const WorkingDaysStyles = styled.div`
  .daysGrid {
    display: flex;
    flex-direction: column;
    gap: ${({ theme }) => theme.spacing[16]};
  }

  .dayCard {
    display: inline-flex;
    align-items: center;
    align-self: flex-start;
    height: 52px;
    user-select: none;
    border-radius: ${({ theme }) => theme.radius[12]};
    padding: ${({ theme }) => theme.spacing[12]} ${({ theme }) => theme.spacing[24]};
    background: ${({ theme }) => theme.colors.semantic.container.white};
    border: 1px solid ${({ theme }) => theme.colors.semantic.outline.default};
    box-shadow: none;
    transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);

    &.active {
      background: ${({ theme }) => theme.colors.accent[50]};
      border-color: ${({ theme }) => theme.colors.accent[200]};

      .dayName {
        color: ${({ theme }) => theme.colors.semantic.text.strong};
      }

      .timePickersSection {
        max-width: 380px;
        opacity: 1;
        margin-left: ${({ theme }) => theme.spacing[40]};
      }
    }

    /* The inline card sizes to its content and overflows a phone; below the
       tablet breakpoint make it full width and stack the time pickers under the
       day + toggle header so nothing gets cut off. */
    ${media.maxTablet`
      display: flex;
      width: 100%;
      flex-direction: column;
      align-items: stretch;
      align-self: stretch;
      height: auto;

      .dayCardHeader {
        justify-content: space-between;
      }

      &.active .timePickersSection {
        max-width: 100%;
        margin-left: 0;
        margin-top: 12px;
      }
    `}
  }

  .dayCardHeader {
    display: flex;
    align-items: center;
    gap: ${({ theme }) => theme.spacing[16]};
  }

  .dayName {
    font-weight: ${({ theme }) => theme.typography.title.t2.weight};
    font-size: ${({ theme }) => theme.typography.body.b1.size};
    line-height: ${({ theme }) => theme.typography.body.b1.lineHeight};
    text-transform: capitalize;
    color: ${({ theme }) => theme.colors.semantic.text.weak};
    transition: color 0.2s ease;
    min-width: 100px;
  }

  .timePickersSection {
    max-width: 0;
    opacity: 0;
    overflow: visible;
    margin-left: 0;
    transition: max-width 0.3s cubic-bezier(0.4, 0, 0.2, 1),
      opacity 0.25s ease,
      margin-left 0.25s ease;
    display: flex;
    align-items: center;
    gap: ${({ theme }) => theme.spacing[16]};
    flex-shrink: 0;
  }

  .timeSeparator {
    color: ${({ theme }) => theme.colors.semantic.text.weak};
    font-size: 14px;
    flex-shrink: 0;
  }

  .timeField {
    flex-shrink: 0;

    > div {
      width: auto;
    }

    .react-datepicker-wrapper {
      display: inline-flex;
    }

    .input {
      display: inline-flex;
    }

    .errorMessage {
      display: none;
    }
  }
`;
